import React, { useContext, useEffect, useState } from 'react'
import { CFormSwitch } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilPencil } from '@coreui/icons'
import moment from 'moment'
import SearchTable from 'src/components/searchTable'
import { activeArray, checkPermissions } from 'src/views/utils/helper'
import CreateVenueModal from './createVenueModal'
import { GlobalContext } from '../../context/GlobalState'
import { PERMISSIONS } from '../../utils/permissions'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'
import useAxios from 'axios-hooks'
import { VENUE_CUSTOM_META_DATA_API, VENUE_LIST_API } from '../../utils/urls'
import { AppContext } from '../../context/app'
import { raiseToast } from '../../utils/helper'

const Venues = () => {
  const { setLoader, accountObj } = useContext(AppContext)
  const language = localStorage.getItem('language')
  const [venues, setVenues] = useState([])
  const [selectedVenue, setSelectedVenues] = useState({})

  const [openModal, setOpenModal] = useState(false)

  const { userSessionObj } = useContext(GlobalContext)
  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.VENUE.CREATE) &&
    defaultLangCheck

  const isUpdateAllowed = checkPermissions(
    userSessionObj.session_data.permissions,
    PERMISSIONS.VENUE.UPDATE,
  )

  const [{ data: venueList, loading: venueListLoading }, venueListCall] = useAxios(
    {
      url: VENUE_LIST_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: createVenue, loading: createVenueLoading }, venueCreateCall] = useAxios(
    {
      url: VENUE_LIST_API,
      method: 'post',
    },
    { manual: true },
  )

  const [{ data: updateVenue, loading: updateVenueLoading }, venueUpdateCall] = useAxios(
    {
      url: VENUE_LIST_API,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: customMetadataList, loading: customMetadataLoading }, customMetadataCall] =
    useAxios(
      {
        url: VENUE_CUSTOM_META_DATA_API,
        method: 'get',
      },
      { manual: true },
    )

  useEffect(() => {
    customMetadataCall()
    venueListCall()
  }, [])

  useEffect(() => {
    setLoader(venueListLoading || createVenueLoading || updateVenueLoading || customMetadataLoading)
  }, [venueListLoading, createVenueLoading, updateVenueLoading, customMetadataLoading])

  useEffect(() => {
    if (venueList && venueList.success) {
      setVenues(venueList.data)
    }
  }, [venueList])

  useEffect(() => {
    if (createVenue && createVenue.success) {
      venueListCall()
      raiseToast('success', 'Venue created successfully')
    }
  }, [createVenue])

  useEffect(() => {
    if (updateVenue && venueList.success) {
      venueListCall()
      raiseToast('success', 'Venue updated successfully')
    }
  }, [updateVenue])

  const handleStatus = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    editVenue({ status: !info.status }, info._id)
  }

  const addVenue = (payload) => {
    venueCreateCall({
      data: payload,
    })
    setOpenModal(false)
  }

  const editVenue = (payload, id) => {
    venueUpdateCall({
      params: {
        venue_id: id,
      },
      data: payload,
    })
    setOpenModal(false)
  }

  const handleEdit = (info) => {
    if (!isUpdateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedVenues(info)
    setOpenModal(true)
  }

  const handleAdd = () => {
    if (!isCreateAllowed) {
      raiseToast('error', "You don't have enough permission")
      return
    }
    setSelectedVenues({})
    setOpenModal(!openModal)
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 27,
    },
    {
      header: 'Address',
      dataCell: (info) => info.address,
      width: 33,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 13,
    },
    {
      header: 'Status',
      dataCell: (info) => (
        <CFormSwitch
          label={info.status ? 'Active' : 'Disabled'}
          checked={info.status}
          valid={info.status}
          value={info.status}
          onChange={() => handleStatus(info)}
          size="lg"
        />
      ),
      width: 15,
    },

    {
      header: <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />,
      dataCell: (info) => (
        <CIcon
          icon={cilPencil}
          style={{ cursor: 'pointer' }}
          size="lg"
          title="Edit"
          onClick={() => handleEdit(info)}
        />
      ),
      width: 7,
    },
  ]

  return (
    <>
      <h4>Venues</h4>
      <p>{`Manage your Venues`}</p>
      <SearchTable
        type={`Venue`}
        tableCardHeight={65}
        disableButton={false}
        buttonName={`+ Add`}
        buttonFunction={handleAdd}
        searchTerm={`name`}
        tableContent={venues}
        tableConfig={tableConfig}
        createPermission={isCreateAllowed}
        disabledButtonTitle={defaultLangCheck ? '' : 'Adding Venue Available on Default Language'}
      />

      {openModal && (
        <CreateVenueModal
          data={selectedVenue}
          openModal={openModal}
          onCancel={() => {
            setOpenModal(false)
            setSelectedVenues({})
          }}
          addCallback={addVenue}
          updateCallback={editVenue}
          customMetadataMaster={activeArray(customMetadataList?.data)}
        />
      )}
    </>
  )
}

export default Venues
